<template>
  <div>
    <dx-data-grid
      :data-source="profileData.data._formatted.crmProfiles"
      :show-borders="true"
      :column-auto-width="true"
      :word-wrap-enabled="true"
      class="master-detail-list"
      no-data-text="No Profile"
      :allow-column-reordering="true"
      :allow-column-resizing="true"
      :column-min-width="50"
      columnResizingMode="widget"
    >
      <dx-paging :page-size="5"/>

      <dx-column
        data-field="id"
        caption="ID"
        data-type="number"
        :width="100"
      />
      <dx-column
        data-field="crM_Adress_id"
        caption="Address ID"
        data-type="number"
        :width="100"
      />
      <dx-column
        data-field="description_open_en"
        caption="Description Open EN"
        :encodeHtml="false"
        :width="200"
      />
      <dx-column
        data-field="profiltypId"
        caption="Profile Type"
        :calculate-cell-value="calculateProfileType"
        sort-order="asc"
        :width="100"
      />
      <dx-column
        :caption="$t('recherche.search.vleadersproblemopportunity')"
        data-field="vleadersproblemopportunity"
        :width="200"
        :allow-sorting="false"
        :allow-filtering="false"
        :encodeHtml="false"
      />
      <dx-column
        :caption="$t('recherche.search.vleadersProductservice')"
        data-field="vleadersProductservice"
        :width="200"
        :allow-sorting="false"
        :allow-filtering="false"
        :encodeHtml="false"
      />
      <dx-column
        caption="Vleaders Technology"
        data-field="vleadersTechnologie"
        :width="200"
        :allow-sorting="false"
        :allow-filtering="false"
        :encodeHtml="false"
      />
      <dx-column
        caption="Vleaders Target Customers"
        data-field="vleadersTargetcustomers"
        :width="200"
        :allow-sorting="false"
        :allow-filtering="false"
        :encodeHtml="false"
      />
      <dx-column
        caption="Vleaders Market Competition"
        data-field="vleadersMarketcompetition"
        :width="200"
        :allow-sorting="false"
        :allow-filtering="false"
        :encodeHtml="false"
      />
      <dx-column
        caption="Vleaders Team"
        data-field="vleadersTeam"
        :width="200"
        :allow-sorting="false"
        :allow-filtering="false"
        :encodeHtml="false"
      />
      <dx-column
        caption="Vleaders Achievements"
        data-field="vLeadersAchievements"
        :width="200"
        :allow-sorting="false"
        :allow-filtering="false"
        :encodeHtml="false"
      />
      <dx-column
        caption="Vleaders Financials"
        data-field="vleadersFinancials"
        :width="200"
        :allow-sorting="false"
        :allow-filtering="false"
        :encodeHtml="false"
      />
    </dx-data-grid>
  </div>
</template>

<script>
  import {
    DxDataGrid,
    DxColumn,
    DxPaging
  } from 'devextreme-vue/data-grid'

  export default {
    components: {
      DxDataGrid,
      DxColumn,
      DxPaging
    },
    props: {
      profileData: {
        type: Object,
        default: () => ({})
      }
    },
    data: () => ({
    }),
    methods: {
      calculateProfileType (rowData) {
        return rowData.profiltypId === 2 ? 'Business' : 'Private'
      }
    }
  }
</script>

<style lang="scss">
  .master-detail-list {
    em {
      font-style: normal;
      background: #e4135973;
      padding: 0px;
    }
  }
</style>
